module.exports = __webpack_public_path__ + "img/PermissionNone.d13ce8c6.png";